import type { TOC } from '@ember/component/template-only';
import PageLoading from '../../components/page-loading.gts';

interface Signature {
  Args: {};
}

const ExploreRecipeLoading: TOC<Signature> = <template>
  <PageLoading
    @title="Recipe"
    @backRoute="explore"
    @backLabel="Back to explore"
  />
</template>;

export default ExploreRecipeLoading;
